<script>

export default {
    data() {
        return {
            data: {},
        };
    },
    mounted() {
        var vm = this;

        vm.load();
    },
    methods: {
        load() {
            var vm = this;

            vm.newData();
            vm.create();
        },
        newData() {
            var vm = this;

            var data = {
                order_time: 0,
                expired: 0,
            };

            vm.data = Object.assign({}, data);
        },
        async create() {
            var vm = this;

            this.$loading.on('config_general_reservation_create');
            try {
                var resp = await this.$api.ConfigReservation.get();
                var data = resp.data.data;

                vm.data = data;

                this.$loading.off('config_general_reservation_create');
            } catch (err) {
                this.$flash.error(err.response.data.message);
            }
        },
        async submit() {
            var vm = this;
            this.$loading.on('config_general_reservation_submit');

            try {
                var postData = vm._createPostData(vm.data);
                var resp = await this.$api.ConfigReservation.create(postData);

                var data = resp.data;

                vm.create();

                this.$flash.success(data.message);
            } catch (err) {
                this.$flash.error(err.response.data.message);
            }
            this.$loading.off('config_general_reservation_submit');
        },
        _createPostData: function (data) {

            return data;
        },
    }
};
</script>

<template>
    <BRow class="justify-content-center">
        <BCol lg="12">
            <b-form @submit="submit()">
                <BCard no-body>
                    <BCardBody>
                        <loading :loading="$loading.get('config_general_reservation_create')" variant="dark"
                            type="block">
                            <BRow>
                                <BCol lg="6 mb-3">
                                    <label class="form-label">{{ $t('config_general.label.order_time')
                                    }}</label>
                                    <div class="input-group">
                                        <input type="number" v-model="data.order_time" class="form-control" id="email"
                                            :placeholder="$t('config_general.placeholder.order_time')" />
                                        <span class="input-group-text" id="basic-addon2">{{ $t('basic.label.minute')
                                        }}</span>
                                    </div>
                                </BCol>
                                <BCol lg="6 mb-3">
                                    <label class="form-label">{{ $t('config_general.label.expired')
                                    }}</label>
                                    <div class="input-group">
                                        <input type="number" v-model="data.expired" class="form-control" id="email"
                                            :placeholder="$t('config_general.placeholder.expired')" />
                                        <span class="input-group-text" id="basic-addon2">{{ $t('basic.label.minute')
                                        }}</span>
                                    </div>
                                </BCol>
                            </BRow>
                        </loading>
                    </BCardBody>
                    <BCardFooter v-if="$ac.hasAccess('config_general_create')">
                        <div class="hstack gap-2 justify-content-end">
                            <BButton type="submit" variant="success" class="w-sm"
                                :disabled="$loading.get('config_general_reservation_submit')">
                                <loading :loading="$loading.get('config_general_reservation_submit')" variant="light"
                                    type="button">
                                    <i class="mdi mdi-floppy me-1"></i>
                                    {{ $t('basic.btn.save') }}
                                </loading>
                            </BButton>
                        </div>
                    </BCardFooter>
                </BCard>
            </b-form>
        </BCol>
    </BRow>
</template>